
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import axios from 'axios';

export default {
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
  },
  methods: {
    submitForm() {
      this.$refs['step2Form'].validate((valid) => {
        // create new contact in hubspot
        this.createOrUpdateHubspotContact();
        
        if (valid) {
          this.isLoading = true;
          var _this = this;
          axios({url: "/mingdao/common/sysfeedback/mgxyContact.ht", method: 'post', 
            data: {
              lastName: _this.step2Form.lastName,
              firstName: _this.step2Form.firstName,
              email: _this.step2Form.email,
              phone: _this.step2Form.phone,
              content: _this.step2Form.content
            },
            transformRequest: [function (data) {
              let ret = ''
              for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
              }
              return ret
            }],
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(res => {
            this.isLoading = false;
            this.$router.push({
              path: `/thank-you`,
              query: {}
            });
          });
        } else {
          console.log('error submit!!');
        }
      });
    },
    createOrUpdateHubspotContact() {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'website_contact_us_tag', value: 'Website new drop us a line' },
        { property: 'firstname', value: _this.step2Form.firstName },
        { property: 'lastname', value: _this.step2Form.lastName },
        { property: 'phone', value: _this.step2Form.phone },
        { property: 'website_contact_us_content', value: _this.step2Form.content }
      ];

      console.log(dataProperties)

      const body = {
        email: _this.step2Form.email,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },
  }, //end of methods
  mounted() {
  },
	head() {
    return {
      title: 'Contact Us | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Contact American Credit today to help find the perfect business lending solution for your specific needs and goals. Quick Decision. Quick Funding. Apply Now!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'american credit background, business financing, american credit history, american credit'
        }
      ]
    }
  }
};
